import { fg } from '@atlaskit/platform-feature-flags/fg';

export default {
	get(): boolean {
		return fg('mercury_strategic_events_recent_activity_events');
	},
};
